<template>
  <ul class="nav navbar-nav navbar-right">
    <li v-if="!hide">
      <a id="close-designer" @click="closeEditor">
        <i class="glyphicon glyphicon-remove"></i>
      </a>
    </li>
  </ul>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: 'CloseButton',
  props: {
    hide: {
      type: Boolean,
      default: false
    }
  },
  methods: mapActions(['closeEditor'])
};
</script>

<style scoped>
#close-designer {
  cursor: pointer;
  margin-right: 15px;
  font-size: 13px;
}

.navbar-right.hiddenbtn {
  margin-right: 15px;
}
</style>
